import { Theme } from '@/theme';
import styled, { css } from 'styled-components';

// If set to `true`, AppWrapper will remove "overflow-y: auto;"
// and set both axis to "hidden". Default is `false`:
type AppWrapperAttributes = {
  $overflow?: boolean;
};

export const AppWrapper = styled.div(
  ({ $overflow }: AppWrapperAttributes) => css`
    background-image: radial-gradient(
      50% 50% at 50% 50%,
      #f5783a 0%,
      ${Theme.color.red} 100%
    );

    background-position: center top;

    overflow: hidden auto;
    // min-height: 100vmax;
    position: relative;

    min-height: 100dvh;
    min-height: 100svh;
    max-height: 100vh;

    display: block;
    width: 100%;

    ${$overflow &&
    css`
      overflow: hidden;
    `}
  `
);

// If set to `false`, ContentWrapper will use full
// screen width on tablet devices. Default is `true`:
type ContentWrapperAttributes = {
  $clamp?: boolean;
};

export const ContentWrapper = styled.div(
  ({ $clamp = true }: ContentWrapperAttributes) => css`
    // min-height: 100vmax;
    position: relative;

    min-height: 100dvh;
    min-height: 100svh;
    max-height: 100vh;

    display: block;
    margin: 0 auto;

    height: 100%;
    width: 100%;

    ${$clamp &&
    css`
      max-width: ${Screen.MAX};
    `}
  `
);

export const ScreenWrapper = styled.section`
  justify-content: center;
  flex-direction: column;

  align-items: center;
  min-height: 100vmax;
  position: relative;

  max-width: 768px;
  margin: 0 auto;
  display: flex;

  height: 100%;
  width: 100%;
`;

export enum Screen {
  MIN = '320px',
  MAX = '430px'
}

export enum zIndex {
  MIN = -2147483648,
  MAX = 2147483647
}
